export const PENDING = "pendingGames";
export const CURRENT = "currentGames";
export const COMPLETED = "completedGames";
export const HISTORICAL = "historicalGames";
export const TEMPLATES = "canUseAsTemplate";
